import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { QUEUE_ENTRY_STATUS } from "~/helpers/sw/messageContract";
import { markQueueReplayFailed, markQueueReplaySuccess } from "~/store/offlineQueueSlice";
import tenantChanged from "~/store/tenantChanged";

export type OnHandChangeType = "add" | "set";

export interface OnHandChange {
	locationId: string;
	quantity: number;
	type: OnHandChangeType;
}

export interface MaterialPendingWrite {
	actionKey: string;
	changes: OnHandChange[];
	materialItemId: string;
}

export interface MaterialPendingWritesState {
	byActionKey: Record<string, MaterialPendingWrite>;
}

const initialState: MaterialPendingWritesState = {
	byActionKey: {}
};

export const materialPendingWritesSlice = createSlice({
	extraReducers: (builder) => {
		builder.addCase(markQueueReplaySuccess, (state, action) => {
			const { reconciliationId } = action.payload;
			if (reconciliationId !== undefined) delete state.byActionKey[reconciliationId];
		});
		builder.addCase(markQueueReplayFailed, (state, action) => {
			const { reconciliationId, retryable, status } = action.payload;
			const isGivenUp = retryable === false && status !== QUEUE_ENTRY_STATUS.RETRYING;
			if (isGivenUp && reconciliationId !== undefined) delete state.byActionKey[reconciliationId];
		});
		builder.addCase(tenantChanged, () => initialState);
	},
	initialState,
	name: "materialPendingWrites",
	reducers: {
		addPendingWrite: (state, action: PayloadAction<MaterialPendingWrite>) => {
			state.byActionKey[action.payload.actionKey] = action.payload;
		},
		removePendingWrite: (state, action: PayloadAction<string>) => {
			delete state.byActionKey[action.payload];
		}
	}
});

export const { addPendingWrite, removePendingWrite } = materialPendingWritesSlice.actions;

export default materialPendingWritesSlice.reducer;
